/**
 * Custom hook untuk mengambil data mapping Channex (room type / rate plan asal OTA)
 * dari sebuah booking.
 *
 * API Endpoint: GET `/v4/booking/{id}/channex-mapping`
 *
 * @param {string} bookingId - ID booking (baris kamar) yang ingin dicek mapping-nya
 * @example
 * const { data, isLoading } = useBookingChannexMapping(bookingId);
 */

import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { BookingChannexMappingResponse } from "../response/BookingChannexMappingResponse";

const useBookingChannexMapping = (bookingId?: string) => {
    return useQuery({
        queryKey: ['booking', bookingId, 'channex-mapping'],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/v4/booking/${bookingId}/channex-mapping`);

                const validationResult = BookingChannexMappingResponse.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Channex mapping data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Channex mapping for booking ${bookingId}`, error);
                throw error;
            }
        },
        enabled: !!bookingId,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false,
    });
};

export default useBookingChannexMapping;
